import { jsx as _jsx } from "react/jsx-runtime";
import GenericSettingsPage from './GenericSettingsPage';
export default function SectionHeightsPage() {
    const columns = [
        { key: 'value', label: 'HEIGHT', type: 'number', required: true, step: 0.1, min: 0 },
        { key: 'unit', label: 'Unit', type: 'text', required: true, defaultValue: 'ft' },
        { key: 'display_name', label: 'Display Name', type: 'text', required: true },
        { key: 'sort_order', label: 'Sort Order', type: 'number', required: true, defaultValue: 0 },
    ];
    return (_jsx(GenericSettingsPage, { tableName: "section_heights", title: "Section Heights", columns: columns, apiPath: "section_heights" }));
}
